// @flow
import CategoriesNav from './CategoriesNav';

export default CategoriesNav;
